import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { red } from '@mui/material/colors';

const useStyles = makeStyles((theme) => ({
    content_tabs: {
        borderBottom: '1px solid #eee',
    },
    tabs: {
        borderRadius: theme.spacing(0.5, 0.5, 0, 0),
        padding: theme.spacing(1, 2),
        "&:hover": {
            cursor: 'pointer',
        },
        color: theme.palette.text.disabled,
    },
    tabs_active: {
        borderTop: '1px solid #ccc',
        borderRight: '1px solid #ccc',
        borderLeft: '1px solid #ccc',
        color: theme.palette.text.primary,
        fontWeight: '400'
    },
    count: {
        marginLeft: theme.spacing(0.5) + '!important',
        padding: theme.spacing(0, 1),
        borderRadius: theme.spacing(0.5),
        color: theme.palette.common.white,
        background: red[400],
    },
}));

export default function CustomTabs(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { active, items, onChangeTab, showCount, count } = props;

    return (
        <Grid item xs={12} marginTop={1} container direction='row' className={classes.content_tabs}>
            {items && items.length > 0 && items.map((item, index) => {
                return (
                    <Box key={index} className={classNames(classes.tabs, active == item.value ? classes.tabs_active : null)}
                        onClick={() => onChangeTab(item.value)}
                    >
                        <div className={classes.tab}>
                            {item.label}
                            {showCount && item.count > 0 && <Typography variant="caption" className={classes.count}>{item.count}</Typography>}
                        </div>
                    </Box>
                );
            })}
        </Grid>
    );
}